// extracted by mini-css-extract-plugin
export default {"panel":"popup_panel__KLjXW","overlay":"popup_overlay__Vw+bM","close":"popup_close__BriGX"};